import {KycResultsBlockComponent} from './kyc-results.block.component';
import {KYCResultsCorporateComponent} from './kyc-results.corporate.component';
import {KYCResultsPrivateComponent} from './kyc-results.private.component';


export const KYC_VERIFICATION_RESULTS_COMPONENTS = [
    KYCResultsCorporateComponent,
    KYCResultsPrivateComponent,
    KycResultsBlockComponent
];


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/kyc/results/index.ts